export enum TaskStatusId {
	New = 1,
	InProgress = 2,
	Waiting = 3,
	Done = 4,
}
